import { lazy } from 'react';
import { RouteObject } from 'react-router';
import { pagePath } from '../utils/consts/pagePath';

const SettingsPage = lazy(() => import('../../view/pages/SettingsPage'));

export const settingsRoutes: RouteObject = {
  path: pagePath.settings,
  children: [
    {
      index: true,
      element: <SettingsPage />,
    },
  ],
};
